import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserInfoService } from '../../../services/user-info.service';
import { DateTimeService } from '../../../services/date-time.service';
import { RDMClientService } from '../../../services/rdm-client.service';
import { HttpErrorHandlerService } from '../../../services/http-error-handling.service';
import { DateFormat } from '../../../interfaces/base-core-services.interface';
import { EnvironmentService } from '../../../services/environment.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import * as _ from 'lodash';


@Component({
  selector: 'app-risk-feedback',
  templateUrl: './risk-feedback.component.html',
  styleUrls: ['./risk-feedback.component.less']
})


export class RiskFeedbackComponent implements OnInit {

  @Input() public value:any;
  public infoSourceList:any[] = [];
  public ministryNameList:any[] = [];
  public departmentNameList:any[] = [];
  public riskAreaTypeList:any[] = [];
  public priorityType:any[] = [];
  public severityType:any[] = [];
  public significanceTypeList:any[] = [];
  public buttonName = 'Save';


  public RiskCreateForm: FormGroup;
  public loading = true;
  public remarksMaxLength = 100;
  public busEstDate = new Date();
  public dateRange = [];
  public weburlPattern = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  public submittedBy: string;
  public submittedDate: string;
  public isloading= false;
  public lagalFormList = [];
  public rcvDate = new Date();
  public formData:any;
  public informationId: number;
  public rdmDataList = [];
  public RemarksMaxLength = 200;
  public decisionObj = { 'sourceType': 'IR1055' };
  public optype: string;

  public baseUrl!: string;

  constructor(
    private userInfoService: UserInfoService,
    private fb: FormBuilder,
    private dateTimeService: DateTimeService,
    public rdmClientService: RDMClientService,
    private httpMessages: HttpErrorHandlerService,
    public router: Router,
    private notiService: NzNotificationService,
    private drawerRef: NzDrawerRef,
    private env: EnvironmentService
  ) {
    if (this.router.url.endsWith('risk-asesmnt/risk-create')) {
      this.optype = 'create';
    } else if (this.router.url.endsWith('risk-asesmnt/update-risk')) {
      this.optype = 'update';
    } else {
      this.optype = 'view';
    }
  }

  ngOnInit():void  {
    this.baseUrl = this.env.getEnvironment().wso2amEndPoint + '/dms' + this.env.getEnvironment().wso2amApiVersion;

    this.loadReferences();

    this.initiazedForm();

    this.setUserInfo();

    if (!_.isEmpty(this.value)) {
      this.RiskCreateForm.patchValue(this.value);
      this.buttonName = 'Update';
    }else{
      this.buttonName = 'Add';
    }

  }


  initiazedForm():void {
    this.RiskCreateForm = this.fb.group({
      name: ['', [Validators.required]],
      nameInOtherLanguage: ['', [Validators.required]],
      receivedDate: [this.dateTimeService.getDateFormat(new Date(), DateFormat.MM_DD_YYYY), [Validators.required]],
      infoSource: [null, [Validators.required]],
      rcvDate: [this.rcvDate, Validators.required],
      ministryName: [''],
      departmentName: [''],
      informerName: [''],
      informerLocation: [''],
      informerContactNumber: [''],
      mediaName: [''],
      emailId: [''],
      senderName: [''],
      conatctNumSender: [''],
      personNameWroteLetter: [''],
      informerAddress: [''],
      otherInfoSource: [''],
      infoDescription: ['', [Validators.maxLength(this.RemarksMaxLength), Validators.required]],
      riskArea: [null],
      reliabilityPercentage: [100],
      priority: [null],
      severity: [null],
      significance: [null],
      status: ['Draft'],
      submitterRemarks: [''],
      submittedBy: this.userInfoService.getUserName(),
      submittedDate: this.dateTimeService.getDateFormat(new Date(), DateFormat.MM_DD_YYYY)
    });
  }


  private loadReferences() {
    this.rdmClientService.getLOVs('kc-profile-risk-source-of-information').subscribe((res:any) => {
      this.infoSourceList = res.content[0]['refValue'];
    });
    this.rdmClientService.getLOVs('kc-profile-risk-name-of-the-ministry').subscribe((res:any) => {
      this.ministryNameList = res.content[0]['refValue'];
    });
    this.rdmClientService.getLOVs('kc-profile-risk-name-of-the-department').subscribe((res:any) => {
      this.departmentNameList = res.content[0]['refValue'];
    });
    this.rdmClientService.getLOVs('kc-profile-risk-area').subscribe((res:any) => {
      this.riskAreaTypeList = res.content[0]['refValue'];
    });
    this.rdmClientService.getLOVs('kc-profile-risk-severity').subscribe((res:any) => {
      this.priorityType = res.content[0]['refValue'];
    });
    this.rdmClientService.getLOVs('kc-profile-risk-severity').subscribe((res:any) => {
      this.severityType = res.content[0]['refValue'];
    });
    this.rdmClientService.getLOVs('kc-profile-risk-significance').subscribe((res:any) => {
      this.significanceTypeList = res.content[0]['refValue'];
    });
  }

  setUserInfo():void  {
    this.submittedBy = this.userInfoService.getUserName();
    this.submittedDate = this.dateTimeService.getDateFormat(new Date(), DateFormat.MM_DD_YYYY);
  }

  submitRiskInfo(isSave: boolean): void {
    this.optype = this.value ? 'update' : 'create';
    const riskStatus = isSave ? 'Pending Final Approval' : 'Draft';
    this.RiskCreateForm.controls['status'].setValue(riskStatus);

    for (const i in this.RiskCreateForm.controls) {
      if(i in this.RiskCreateForm.controls){
        this.RiskCreateForm.controls[i].markAsDirty();
        this.RiskCreateForm.controls[i].updateValueAndValidity();
      }
    }

    if (this.RiskCreateForm.valid) {
      this.isloading = true;
      if (this.optype == 'create') {
        this.drawerRef.close(this.RiskCreateForm);
        this.isloading = false;
      } else if (this.optype == 'update') {
        this.drawerRef.close(this.RiskCreateForm);
        this.isloading = false;
      } else {
        return;
      }
    }
  }


  onChangeReceivedDate(result: Date): void {
    this.RiskCreateForm.controls['receivedDate'].setValue(this.dateTimeService.getDateFormat(result, DateFormat.MM_DD_YYYY));
  }

  keyPress(event:any):void  {
    // eslint-disable-next-line no-useless-escape
    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  numberOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  close(): void {
    this.drawerRef.close();
  }


}
